/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Name_PlaceholderInputs */

const en_form_name_placeholder = /** @type {(inputs: Form_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const ar_form_name_placeholder = /** @type {(inputs: Form_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاسم`)
};

const bn_form_name_placeholder = /** @type {(inputs: Form_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নাম`)
};

const de_form_name_placeholder = /** @type {(inputs: Form_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const es_form_name_placeholder = /** @type {(inputs: Form_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

const fr_form_name_placeholder = /** @type {(inputs: Form_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

const pt_form_name_placeholder = /** @type {(inputs: Form_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const zh_form_name_placeholder = /** @type {(inputs: Form_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名称`)
};

const tr_form_name_placeholder = /** @type {(inputs: Form_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ad`)
};

const ru_form_name_placeholder = /** @type {(inputs: Form_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя`)
};

const pl_form_name_placeholder = /** @type {(inputs: Form_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazwa`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Form_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_name_placeholder = /** @type {((inputs?: Form_Name_PlaceholderInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Name_PlaceholderInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_name_placeholder(inputs)
	if (locale === "bn") return bn_form_name_placeholder(inputs)
	if (locale === "de") return de_form_name_placeholder(inputs)
	if (locale === "es") return es_form_name_placeholder(inputs)
	if (locale === "fr") return fr_form_name_placeholder(inputs)
	if (locale === "pt") return pt_form_name_placeholder(inputs)
	if (locale === "zh") return zh_form_name_placeholder(inputs)
	if (locale === "tr") return tr_form_name_placeholder(inputs)
	if (locale === "ru") return ru_form_name_placeholder(inputs)
	if (locale === "pl") return pl_form_name_placeholder(inputs)
	return en_form_name_placeholder(inputs)
});